import { createBrowserRouter, Navigate } from 'react-router-dom'
import { ProtectedShell } from './components/ProtectedShell'
import { Login } from './pages/Login'
import { AuthCallback } from './pages/AuthCallback'
import { Dashboard } from './pages/Dashboard'
import { Briefs } from './pages/Briefs'
import { BriefDetail } from './pages/BriefDetail'
import { Intake } from './pages/Intake'
import { Partners } from './pages/admin/Partners'
import { Users } from './pages/admin/Users'
import { PptxTemplates } from './pages/admin/PptxTemplates'
import { Webhooks } from './pages/admin/Webhooks'
import { NotFound } from './pages/NotFound'
import { RouteError } from './components/RouteError'

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/dashboard" replace /> },
  { path: '/login', element: <Login /> },
  { path: '/auth/callback', element: <AuthCallback /> },
  {
    element: <ProtectedShell />,
    errorElement: <RouteError />,
    children: [
      { path: '/dashboard', element: <Dashboard /> },
      { path: '/briefs', element: <Briefs /> },
      { path: '/briefs/:id', element: <BriefDetail /> },
      { path: '/intake/new', element: <Intake /> },
      { path: '/admin/partners', element: <Partners /> },
      { path: '/admin/users', element: <Users /> },
      { path: '/admin/templates', element: <PptxTemplates /> },
      { path: '/admin/webhooks', element: <Webhooks /> },
    ],
  },
  // Catch-all: unmatched paths (e.g. the legacy FastAPI `/app` URL) render the
  // branded 404 instead of React Router's raw dev error boundary. `errorElement`
  // gives thrown route errors the same graceful fallback.
  { path: '*', element: <NotFound />, errorElement: <NotFound /> },
])
